/**
 * Polyfill stable language features. These imports will be optimized by `@babel/preset-env`.
 *
 * See: https://github.com/zloirock/core-js#babel
 */
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'core-js/proposals/reflect-metadata';

interface WindowType extends Window {
  global: Window;
}

((window as unknown) as WindowType).global = window;
